<template>
  <section
      class="main"
      style="position:relative; margin: 0 auto"
      :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}"
  >

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet"
          integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">

    <v-container style="max-width: 1200px; margin: 0 auto">
      <v-row justify="center">
        <v-col class="text" :cols="12" :style="{'font-size': block.fontSize + 'px'}">

          <div class="container" v-if="block.content == 'HOTLINE_CALL_FORM' && !isSubmitted">

            <div class="view-title-2">Обращение</div>

            <form class="row g-3 needs-validation" id="helpCallForm" @submit.prevent="submitHelpCallForm" novalidate>
              <div class="col-12 has-validation">
                <label for="help_name" class="form-label">ФИО</label>
                <input type="text" class="form-control" id="help_name" name="help_name"
                       placeholder="Иванов Иван Иванович" required v-model="name">
                <div class="invalid-feedback">
                  Пожалуйста введите Ваше полное имя
                </div>
              </div>
              <div class="col-md-6 has-validation">
                <label for="help_email" class="form-label">Email</label>
                <input type="email" class="form-control" id="help_email" name="help_email"
                       placeholder="iii@uni-dubna.ru" required v-model="email">
                <div class="invalid-feedback">
                  Пожалуйста введите Ваш адрес электронной почты
                </div>
              </div>
              <div class="col-md-6 has-validation">
                <label for="help_group" class="form-label">Номер группы</label>
                <input type="text" class="form-control" id="help_group" name="help_group" placeholder="1011" required
                 v-model="group">
                <div class="invalid-feedback">
                  Пожалуйста введите Ваш номер группы
                </div>
              </div>
              <div class="col-12 has-validation">
                <label for="help_text" class="form-label">Текст обращения</label>
                <textarea class="form-control" id="help_text" name="help_text" placeholder="Текст обращения"
                          rows="5" required v-model="text"></textarea>
                <div class="invalid-feedback">
                  Пожалуйста введите текст обращения
                </div>
              </div>
              <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="submit" class="btn btn-outline-primary home-link">ОТПРАВИТЬ</button>
              </div>
            </form>
          </div>
          <div class="container" v-else-if="block.content == 'HOTLINE_CALL_FORM' && isSubmitted">
            <div class="alert alert-success" role="alert">
              <h4 class="alert-heading">Ваше обращение было отправлено!</h4>
              <p>Спасибо за обращение</p>
            </div>
          </div>

          <div v-else v-html="block.content">{{ block.content }}</div>

        </v-col>
      </v-row>
    </v-container>

  </section>
</template>
<script>

import {HTTP} from "@/axios";

export default {
  props: ['block'],
  name: "HtmlBlock",
  data() {
    return {
      name: '',
      email: '',
      group: '',
      text: '',
      isSubmitted: false
    }
  },
  methods: {
    submitHelpCallForm() {
      console.log('HELP')
      let data = {
        name: this.name,
        email: this.email,
        group: this.group,
        text: this.text
      }
      if (this.name && this.group && this.text && this.email) {
        HTTP.post("hotline/call", JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json"
          }
        })
            .then(() => {
              console.log('HELP HELP')
              this.isSubmitted = true
            }).catch(() => {
          console.log('HELP HELP HEEELP')
          this.isSubmitted = true
        })
      } else {
        document.querySelector("input#help_name + .invalid-feedback").style.display = 'none'
        document.querySelector("input#help_group + .invalid-feedback").style.display = 'none'
        document.querySelector("textarea#help_text + .invalid-feedback").style.display = 'none'
        document.querySelector("input#help_email + .invalid-feedback").style.display = 'none'
        if (!this.name) {
          document.querySelector("input#help_name + .invalid-feedback").style.display = 'block'
        }
        if (!this.group) {
          document.querySelector("input#help_group + .invalid-feedback").style.display = 'block'
        }
        if (!this.text) {
          document.querySelector("textarea#help_text + .invalid-feedback").style.display = 'block'
        }
        if (!this.email) {
          document.querySelector("input#help_email + .invalid-feedback").style.display = 'block'
        }
      }
    }
  }

}
</script>

<style scoped>

.text {
  color: #000000;
  /*font-size: 3px;*/
  /*line-height: 1.35;*/
  font-family: 'PT Sans', Arial, sans-serif;
  /*font-weight: 400;*/
}

.text textarea {
  width: 100%;
  position: relative;
  overflow: auto;
  z-index: 100;
  height: 350px
}

.text-align-justify {
  text-align: justify;
}

.text-align-left {
  text-align: left;
}

.text-align-right {
  text-align: right;
}

.text-align-center {
  text-align: center;
}

.view-title-2 {
  font-size: 30px;
  color: #18224b;
  line-height: 1.23;
  font-family: 'PT Sans', Arial, sans-serif;
  font-weight: 600;
  padding: 20px 0 60px 0;
  text-align: center;
}

button.btn {
  color: #18224b;
  border: 2px solid #18224b;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Roboto', sans-serif;
}

.main {

}

.hovered {
  opacity: 0;
  transition: 0.3s;
}

.main:hover .hovered {
  opacity: 1;
}

</style>
